import React, { Component } from "react";
import { connect } from "react-redux";

import { createCompany } from "actions/company";
import { fetchRateLimits } from "actions/rateLimit";
import { fetchAvailableGateways } from "actions/availableGateway";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/Company/Form";

class CompanyCreate extends Component {
  componentDidMount() {
    const { fetchRateLimits, fetchAvailableGateways } = this.props;
    fetchRateLimits();
    fetchAvailableGateways();
  }

  handleFormSubmit = data => {
    this.createCompany(data);
  };

  createCompany(data) {
    const {
      toggleNotification,
      toggleFullPageSpinner,
      createCompany,
      history
    } = this.props;
    toggleFullPageSpinner(true);
    createCompany(data)
      .then(() => {
        toggleNotification(true, {
          message: "Created Company Success",
          infoClassName: "is-success"
        });
        history.push(`/companies`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  render() {
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        rateLimits={this.props.rateLimits}
        availableGateways={this.props.availableGateways}
      />
    );
  }
}

const mapStateToProps = ({ company, rateLimits, availableGateways }) => ({
  rateLimits,
  availableGateways
});

export default connect(mapStateToProps, {
  createCompany,
  toggleFullPageSpinner,
  toggleNotification,
  fetchRateLimits,
  fetchAvailableGateways
})(CompanyCreate);



// WEBPACK FOOTER //
// ./src/pages/Company/Create/index.js